/**
 * Prompt Type options, such as Yes/No, Document Upload, etc.
 */
export const enum PromptType {
  Bool = 'BOOL',
  DocumentUpload = 'DOCUMENTS',
  Text = 'TEXT',
}

/**
 * Bool Prompt Input Type.
 */
export type BoolPrompt = { type: PromptType.Bool }

/**
 * Document Upload Prompt Input Type.
 */
export type DocumentUploadPrompt = {
  options: Array<{
    id: string
    title: string
  }>
  type: PromptType.DocumentUpload
}

/**
 * Text Prompt Input Type.
 */
export type TextPrompt = { type: PromptType.Text }

/**
 * Discriminated Union of Prompt Input Types.
 */
export type PromptInput = BoolPrompt | DocumentUploadPrompt | TextPrompt
